<template>
  <div>
    <main-layout>
      <v-tabs v-model="active" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'Reward'" :href="'#Reward'">{{ $t('Reward') }}</v-tab>
        <v-tab ripple :key="'approvePoint'" :href="'#approvePoint'">{{
          $t('Approve Point')
        }}</v-tab>
        <v-tab ripple :key="'redeemsummary'" :href="'#redeemsummary'">{{
          $t('Redeem Summary')
        }}</v-tab>
      </v-tabs>

      <div v-if="active == 'Reward'">
        <RewardManager></RewardManager>
      </div>
      <div v-if="active == 'approvePoint'">
        <ApprovePoint></ApprovePoint>
      </div>
      <div v-if="active == 'redeemsummary'">
        <Redeemsummary></Redeemsummary>
      </div>
    </main-layout>
  </div>
</template>

<script>
import api from '@/api'
import RewardManager from './RewardManager.vue'
import ApprovePoint from './ApprovePoint.vue'
import uploadfile from '@/components/elements/uploadfile'
import selectCategory from './selectCategory.vue'
import Categories from './Categories'
import Redeemsummary from './RedeemSummary'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    uploadfile,
    selectCategory,
    Multiselect,
    Categories,
    RewardManager,
    Redeemsummary,
    ApprovePoint
  },
  data() {
    return {
      active: 'Reward',
      deleteLoading: false,
      showstartdate: false,
      showenddate: false,
      input: {
        name: '',
        photourl: '',
        description: '',
        point: '',
        categoryid: '',
        quantity: '',
        startdate: '',
        enddate: ''
      },
      showAddReward: false,
      savecategoryloading: false,
      showCategory: false,
      categoryaddinput: '',
      addcategory: false,
      categorylist: [],
      rewardlist: [],
      selectedcategory: '',
      saveproductloading: false
    }
  },
  created() {},
  mounted() {
    this.getCategories()
    this.getRewards()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredStartdate() {
      if (this.input.startdate) {
        return moment(this.input.startdate).format('DD/MM/YYYY')
      } else return ''
    },
    filteredEnddate() {
      if (this.input.enddate) {
        return moment(this.input.enddate).format('DD/MM/YYYY')
      } else return ''
    },
    filteredProducts() {
      if (this.categorylist.length && this.rewardlist) {
        return this.rewardlist.filter((el) => el.categoryid == this.selectedcategory)
      } else return []
    }
  },
  methods: {
    updateproduct() {
      var vm = this
      var data = { ...vm.input, categoryid: vm.input.categoryid.id, pageid: vm.selectedBot.pageid }
      vm.$validator.validateAll().then((result) => {
        if (result) {
          vm.saveproductloading = true
          api.putsahapanrewardproducts(data, (err, response) => {
            vm.saveproductloading = false
            if (response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'แก้ไขสำเร็จ'
                })
                .then(() => {
                  var index = vm.rewardlist.findIndex((el) => el.id == vm.input.id)
                  vm.$set(vm.rewardlist, index, data)
                  vm.closeform()
                })
            }
          })
        }
      })
    },
    closeform() {
      this.input = {
        name: '',
        photourl: '',
        description: '',
        point: '',
        categoryid: '',
        quantity: '',
        startdate: '',
        enddate: ''
      }
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
      this.showAddReward = false
    },
    editProduct(item) {
      var vm = this
      this.input = {
        ...item,
        categoryid: this.categorylist.find((el) => el.id == item.categoryid),
        startdate: moment(item.startdate).format('YYYY-MM-DD'),
        enddate: moment(item.enddate).format('YYYY-MM-DD')
      }
      this.showAddReward = true
    },
    onChangeCategory(e) {
      this.selectedcategory = e
    },
    saveproduct() {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (result) {
          vm.saveproductloading = true
          api.postsahapanrewardproducts(
            { ...vm.input, categoryid: vm.input.categoryid.id },
            (err, response) => {
              vm.saveproductloading = false
              if (response.responsecode == 200) {
                vm.$swal
                  .fire({
                    type: 'success',
                    text: 'เพิ่มสำเร็จ'
                  })
                  .then(() => {
                    vm.rewardlist.push({
                      ...vm.input,
                      id: response.data[0].id,
                      categoryid: vm.input.categoryid.id
                    })
                    vm.closeform()
                  })
              }
            }
          )
        }
      })
    },
    onCategoryChange: function () {
      let vm = this
    },
    getCategories() {
      var vm = this
      api.getsahapanrewardcategories((err, response) => {
        if (response.responsecode == 200) {
          vm.categorylist = response.data
          vm.selectedcategory = response.data[0].id
        }
      })
    },
    getRewards() {
      var vm = this
      api.getsahapanrewardproducts((err, response) => {
        if (response.responsecode == 200) {
          if (response.data) {
            vm.rewardlist = response.data
          }
        }
      })
    },
    deleteProduct(item) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        id: item.id
      }
      this.$swal
        .fire({
          text: 'คุณต้องการลบรายการนี้ใช่หรือไม่?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            vm.deleteLoading = true
            api.deletesahapanrewardproducts(data, (err, response) => {
              vm.deleteLoading = false
              if (response.responsecode == 200) {
                var index = vm.rewardlist.findIndex((el) => el.id == item.id)
                vm.rewardlist.splice(index, 1)
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.category-box {
  min-height: 120px;
  border: 0.5px solid black;
}
.item-category {
  height: 50px;
  border: solid #ff706b 1px;
}
.add-product {
  height: 80px;
  border: dashed rgb(189, 189, 189) 1.2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(189, 189, 189);
  cursor: pointer;
}
.add-product:hover {
  color: rgb(128, 128, 128);
  border: dashed rgb(128, 128, 128) 1.2px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/sahapan/main.vue